import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterByCategory } from "../redux/filterBooks/actions";

export default function BookFilter() {
  const filter = useSelector((state) => state.filter.category);
  const dispatch = useDispatch();
  const handleFeaturedClick = (text) => {
    dispatch(filterByCategory(text));
  };
  return (
    <div className="flex items-center justify-between mb-12">
      <h4 className="mt-2 text-xl font-bold">Book List</h4>
      <div className="flex items-center space-x-4">
        <button
          className={
            filter === "all" ? "filter-btn active-filter" : "filter-btn"
          }
          id="lws-filterAll"
          onClick={() => handleFeaturedClick("all")}
        >
          All
        </button>
        <button
          className={
            filter === "featured" ? "filter-btn active-filter" : "filter-btn"
          }
          id="lws-filterFeatured"
          onClick={() => handleFeaturedClick("featured")}
        >
          Featured
        </button>
      </div>
    </div>
  );
}
